/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchPrivacyRequests} from '../api'

export const useMutationSearchPrivacyRequests = createReactQueryMutationHook('searchPrivacyRequests', searchPrivacyRequests)
